const moment = require('moment');

import {dt} from 'l10n';

export function formatDate(memberPhoto) {
    return moment(memberPhoto.upload_date).format(dt('member_photo', 'MM/DD/YYYY'))
}


// WEBPACK FOOTER //
// ./src/utils/memberPhotos.js